var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStorefront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.87736 5.85858C2.94773 5.36593 3.36966 5 3.86731 5H16.1327C16.6304 5 17.0523 5.36593 17.1227 5.85858L18.837 17.8586C18.923 18.461 18.4555 19 17.847 19H2.15302C1.54447 19 1.07701 18.461 1.16307 17.8586L2.87736 5.85858Z",
    fill: "currentColor",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1328 5H3.86737C3.36971 5 2.94779 5.36593 2.87742 5.85858C2.79135 6.46101 3.25882 7 3.86737 7H16.1328C16.7413 7 17.2088 6.46101 17.1227 5.85858C17.0523 5.36593 16.6304 5 16.1328 5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9V4C7 2.34315 8.34315 1 10 1V1C11.6569 1 13 2.34315 13 4V9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStorefront);
export default __webpack_public_path__ + "static/media/icon-storefront.e72ac88fb60f017331650ab8b962fc0f.svg";
export { ForwardRef as ReactComponent };